// import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import Button from "react-bootstrap/Button";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import React, { useState, useEffect, useRef } from "react";
// import { NavLink } from "react-router-dom";
// import "./Header.css";
// import Logout_Modal from "./logout/Logout_Modal";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSortDown } from "@fortawesome/free-solid-svg-icons";

// const Header = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [expanded, setExpanded] = useState(false);

//   const [isProfileOpen, setIsProfileOpen] = useState(false);

//   const handleNavClick = () => {
//     setExpanded(false);
//     setIsProfileOpen(false);
//   };

//   const isHomePage = location.pathname === "/";
//   const isDetailsPage =
//     location.pathname === "/Expert_Login_Details" ||
//     location.pathname === "/vendor-login-details" ||
//     location.pathname === "/expert-login-details";

//   const showAuthButtons = isHomePage || isDetailsPage;

//   const handleSubscriptionClick = () => {
//     navigate("/login");
//   };

//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         isProfileOpen &&
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target)
//       ) {
//         setIsProfileOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//   }, [isProfileOpen]);

//   return (
//     <>
//       <section className="main_head">
//         <div className="container-fluid p-0">
//           <Navbar
//             expand="lg"
//             expanded={expanded}
//             onToggle={(val) => setExpanded(val)}
//             bg="white"
//             className="header"
//           >
//             <Container className="g-0">
//               <Navbar.Brand href="/">
//                 <img
//                   src="/assets/header/Oll-Type-Services.png"
//                   alt="All Type Services"
//                   className="header-logo"
//                 />
//               </Navbar.Brand>

//               <div className="nav-actions-container order-md-2 ">
//                 {showAuthButtons ? (
//                   <div className="subscription-holder">
//                     <Button
//                       className="subscription-btn"
//                       onClick={handleSubscriptionClick}
//                     >
//                       <img
//                         src="/assets/header/crown (2).png"
//                         alt="Premium"
//                         className="crown-icon"
//                       />
//                       Subscription
//                     </Button>

//                     <Button
//                       className="login-btn ms-2"
//                       onClick={() => navigate("/login")}
//                     >
//                       Log In
//                     </Button>
//                   </div>
//                 ) : (
//                   <div className="header-profile">
//                     <div
//                       className="profile-trigger-wrapper"
//                       onClick={() => setIsProfileOpen(!isProfileOpen)}
//                       style={{
//                         cursor: "pointer",
//                         display: "flex",
//                         alignItems: "center",
//                       }}
//                     >
//                       <div className="profile-trigger">
//                         <img
//                           src="/assets/images/profile-icon.png"
//                           alt="Profile"
//                           className="profile-avatar"
//                         />
//                       </div>
//                       <div className="profile-holder">
//                         <span className="profile-name">Vishal Sawant</span>
//                         <div className="dropdown-icon">
//                           <FontAwesomeIcon icon={faSortDown} />
//                         </div>
//                       </div>
//                     </div>

//                     {isProfileOpen && (
//                       <div className="profile-dropdown-menu">
//                         <Link
//                           to="/profile"
//                           onClick={handleNavClick}
//                           className="profile-item"
//                         >
//                           Profile
//                         </Link>
//                         <div className="profile-divider"></div>
//                         <Link
//                           to="/wallet"
//                           onClick={handleNavClick}
//                           className="profile-item"
//                         >
//                           Wallet
//                         </Link>
//                         <div className="profile-divider"></div>
//                         <Link
//                           to="/history"
//                           onClick={handleNavClick}
//                           className="profile-item"
//                         >
//                           History
//                         </Link>
//                         <div className="profile-divider"></div>
//                         <div
//                           className="profile-item logout-text"
//                           onClick={() => {
//                             setShowLogoutModal(true);
//                             handleNavClick();
//                           }}
//                         >
//                           Logout
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <Navbar.Toggle
//                 aria-controls="basic-navbar-nav"
//                 className="ms-2 order-md-3"
//               />

//               <Navbar.Collapse id="basic-navbar-nav" className="order-md-1">
//                 <Nav className="mx-auto text-center mobile-nav-links">
//                   <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>
//                     Home
//                   </Nav.Link>

//                   {!isDetailsPage && (
//                     <>
//                       <Nav.Link
//                         as={NavLink}
//                         to="/vendors"
//                         onClick={handleNavClick}
//                       >
//                         Vendors
//                       </Nav.Link>
//                       <Nav.Link
//                         as={NavLink}
//                         to="/experts"
//                         onClick={handleNavClick}
//                       >
//                         Expert
//                       </Nav.Link>
//                     </>
//                   )}

//                   <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>
//                     About Us
//                   </Nav.Link>
//                   <Nav.Link
//                     as={NavLink}
//                     to="/contactus"
//                     onClick={handleNavClick}
//                   >
//                     Contact Us
//                   </Nav.Link>
//                 </Nav>
//               </Navbar.Collapse>
//             </Container>

//             <Logout_Modal
//               show={showLogoutModal}
//               handleClose={() => setShowLogoutModal(false)}
//             />
//           </Navbar>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Header;

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";
import Logout_Modal from "./logout/Logout_Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  // Reference for the dropdown container
  const dropdownRef = useRef(null);

  const handleNavClick = () => {
    setExpanded(false);
    setIsProfileOpen(false);
  };

  const isHomePage = location.pathname === "/";
  const isDetailsPage =
    location.pathname === "/Expert_Login_Details" ||
    location.pathname === "/vendor-login-details" ||
    location.pathname === "/expert-login-details";

  const showAuthButtons = isHomePage || isDetailsPage;

  const handleSubscriptionClick = () => {
    navigate("/login");
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isProfileOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsProfileOpen(false);
      }
    };

    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isProfileOpen]);

  return (
    <>
      <section className="main_head">
        <div className="container-fluid p-0">
          <Navbar
            expand="lg"
            expanded={expanded}
            onToggle={(val) => setExpanded(val)}
            bg="white"
            className="header"
          >
            <Container className="g-0">
              <Navbar.Brand href="/">
                <img
                  src="\assets\images\ots-logo.png"
                  alt="All Type Services"
                  className="header-logo"
                />
              </Navbar.Brand>

              <div className="nav-actions-container order-md-2 ">
                {showAuthButtons ? (
                  <div className="subscription-holder">
                    <Button
                      className="subscription-btn"
                      onClick={handleSubscriptionClick}
                    >
                      <img
                        src="/assets/header/crown (2).png"
                        alt="Premium"
                        className="crown-icon"
                      />
                      Subscription
                    </Button>

                    <Button
                      className="login-btn ms-2"
                      onClick={() => navigate("/login")}
                    >
                      Log In
                    </Button>
                  </div>
                ) : (
                  <div className="header-profile" ref={dropdownRef}>
                    <div
                      className="profile-trigger-wrapper"
                      onClick={() => setIsProfileOpen(!isProfileOpen)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div className="profile-trigger">
                        <img
                          src="/assets/images/profile-icon.png"
                          alt="Profile"
                          className="profile-avatar"
                        />
                      </div>
                      <div className="profile-holder">
                        <span className="profile-name">Vishal Sawant</span>
                        <div className="dropdown-icon">
                          <FontAwesomeIcon icon={faSortDown} />
                        </div>
                      </div>
                    </div>

                    {isProfileOpen && (
                      <div className="profile-dropdown-menu">
                        <Link
                          to="/profile"
                          onClick={handleNavClick}
                          className="profile-item"
                        >
                          Profile
                        </Link>
                        <div className="profile-divider"></div>
                        <Link
                          to="/wallet"
                          onClick={handleNavClick}
                          className="profile-item"
                        >
                          Wallet
                        </Link>
                        <div className="profile-divider"></div>
                        <Link
                          to="/history"
                          onClick={handleNavClick}
                          className="profile-item"
                        >
                          History
                        </Link>
                        <div className="profile-divider"></div>
                        <div
                          className="profile-item logout-text"
                          onClick={() => {
                            setShowLogoutModal(true);
                            handleNavClick();
                          }}
                        >
                          Logout
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                className="ms-2 order-md-3"
              />

              <Navbar.Collapse id="basic-navbar-nav" className="order-md-1">
                <Nav className="mx-auto text-center mobile-nav-links">
                  <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>
                    Home
                  </Nav.Link>

                  {!isDetailsPage && (
                    <>
                      <Nav.Link
                        as={NavLink}
                        to="/vendors"
                        onClick={handleNavClick}
                      >
                        Vendors
                      </Nav.Link>
                      <Nav.Link
                        as={NavLink}
                        to="/experts"
                        onClick={handleNavClick}
                      >
                        Expert
                      </Nav.Link>
                    </>
                  )}

                  <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/contactus"
                    onClick={handleNavClick}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>

            <Logout_Modal
              show={showLogoutModal}
              handleClose={() => setShowLogoutModal(false)}
            />
          </Navbar>
        </div>
      </section>
    </>
  );
};

export default Header;
